import {z} from 'zod';

export const socialAuthIntegrationSchema = z.enum([
  'facebook',
  'google',
  'apple',
]);

/** Third-party integrations through which end-users can use for sites-dot login */
export type SocialAuthIntegration = z.infer<typeof socialAuthIntegrationSchema>;
